import React from "react";
import {useSelector} from "react-redux";

function Stats () {

    const profile = useSelector(state => state.profileReducer.getProfile);

    return (
        <div className="stats">
            <div className="stat">
                <p>Puchased licenses:</p>
                <p className="number">
                    {profile.license.licensesNumber}
                </p>
            </div>
            <div className="stat">
                <p>Used licenses:</p>
                <p className="number">
                    {profile.license.licensesUsed}
                </p>
            </div>
            <div className="stat">
                <p>Available licenses:</p>
                <p className="number">
                    {profile.license.licensesAvailable}
                </p>
            </div>
            <div className="stat">
                <p>Google Workspace users:</p>
                <p className="number">
                    {profile.domain.totalUsers}
                </p>
            </div>
        </div>
    )
}

export default Stats;